import { useStorageBackedState } from 'use-storage-backed-state'

export const useRoleIds = () => useStorageBackedState<string[] | null>(null, 'roles')
